import global from './GlobalStore';
import moment from 'moment';
import config from '../configs/appConfig';

import User from '../models/User';
import { generateHash } from '../utils/string';
import { getLoginUserData, getRegisterUserData } from './data/AccountStore.data';

export default class UserStore {
  constructor() {
    this.user = null;
  }

  setUser(user) {
    this.user = user;
  }
  getUser() {
    return this.user;
  }

  userLogin(email, password, callback) {
    if (config.data.fakeLogin) {
      let result = getLoginUserData();
      this.user = new User(result.payload);

      console.log('Logging in with fake data: ' + result);

      callback && callback(result);
    } else {
      return global()
        .getApi()
        .userApi.userLogin(email, password)
        .then((result = {}) => {
          if (result.status === 200 && result.payload) {
            this.user = new User(result.payload);
          } else {
            console.error('Unable to login user: ' + result.error);
          }

          callback && callback(result);
        });
    }
  }

  userRegister(username, email, password, confirmPassword, callback) {
    if (config.data.fakeRegister) {
      let result = getRegisterUserData();
      //let result = getRegisterError();
      this.user = result.payload;

      console.log('Registering user with fake data: ' + result);

      callback && callback(result);
    } else {
      return global()
        .getApi()
        .userApi.userRegister(username, email, password, confirmPassword)
        .then(result => {
          if (result.status === 200 && result.payload) {
            this.user = result.payload;
          } else {
            console.error('Unable to register user: ' + result.error);
          }

          callback && callback(result);
        });
    }
  }

  userSocialLogin({ email, avatarUrl, firstName, lastName }, callback) {
    if (email) {
      return global()
        .getApi()
        .userApi.userSocialLogin({ email, avatarUrl, firstName, lastName })
        .then(result => {
          if (result.status === 200 && result.payload) {
            this.user = result.payload;
          } else {
            console.error('Unable to register user: ' + result.error);
          }

          callback && callback(result);
        });
    }
  }

  getUserFromLocalStorage() {
    let userCategories = [];
    let categories = localStorage.getItem('categories');
    if (categories) {
      categories = categories.split(',');
      categories.forEach(category => {
        userCategories.push(parseInt(category));
      });
    }

    let user = {
      user_id: localStorage.getItem('user_id'),
      first_name: localStorage.getItem('first_name'),
      email: localStorage.getItem('email'),
      avatar_url: localStorage.getItem('avatar_url'),
      token: localStorage.getItem('access_token'),
      tokenExpiration: localStorage.getItem('expires_at'),
      stream_token: localStorage.getItem('stream_token'),
      username: localStorage.getItem('username'),
      emailConfirmed: localStorage.getItem('emailConfirmed'),
      categories: userCategories,
    };

    this.user = new User(user);

    return this.user;
  }

  setUserSessionData(userData) {
    let result = { ...userData };
    result['sessionHash'] = generateHash(moment().format('x'));
    sessionStorage.setItem('clipps_data', JSON.stringify(result));
  }

  getUserStreamToken(userId, callback) {
    return global()
      .getApi()
      .userApi.getUserStreamToken(userId)
      .then(result => {
        if (result.status === 200 && result.payload && result.payload.result) {
          callback && callback(result.payload.result);
        } else {
          console.error('Unable to register user: ' + result.error);
        }
      });
  }

  followUser(userId, followerId, callback) {
    return global()
      .getApi()
      .userApi.followUser(userId, followerId)
      .then(result => {
        if (result.status === 200 && result.payload) {
          callback && callback(result.payload);
        } else {
          console.error('Unable to follow user: ' + result.error);
          callback && callback();
        }
      });
  }

  unfollowUser(userId, followerId, callback) {
    return global()
      .getApi()
      .userApi.unfollowUser(userId, followerId)
      .then(result => {
        if (result.status === 200 && result.payload) {
          callback && callback(result.payload);
        } else {
          console.error('Unable to follow user: ' + result.error);
          callback && callback();
        }
      });
  }

  getUserDetails(userId, callback) {
    return global()
      .getApi()
      .userApi.getUserDetails(userId)
      .then(result => {
        if (result.status === 200 && result.payload && result.payload.user) {
          callback && callback(result.payload.user);
        } else {
          console.error('Unable to follow user: ' + result.error);
          callback && callback();
        }
      });
  }

  updateUserCategories(userId, email, newCategories, callback) {
    return global()
      .getApi()
      .userApi.updateUserCategories(userId, email, newCategories)
      .then(result => {
        if (result.status === 200 && result.payload && result.payload.user) {
          callback && callback(result.payload.user);
        } else {
          console.error('Unable to follow user: ' + result.error);
          callback && callback();
        }
      });
  }
}
